<template>
  <div
    :id="position.positionName + '-container'"
    :class="[
      'position', 
      'pos' + position.column, 
      position.stratum.name.toLowerCase() + '-row']">

    <div class="position-container">
      <div 
        ref="icon-container"
        :class="[
          { 'position--accepts-drop': !!dragging }, 
          'position-icon-container',
          '-position-drop']"
        @dragover.prevent
        @drop.prevent="positionDrop(position)">
        <IconTacticsBoardPosition
          v-if="position.filled"
          :position="position"
          :selected="selected"
          @update:dragging="$emit('update:dragging', $event)"
          @update:selected-position="$emit('update:selected-position', $event)"
          @touch-move-ended="$emit('touch-move-ended', $event)" />
      </div>

      <TacticsBoardPositionName
        v-if="position.filled"
        :position="position"
        :selectedRole="selectedRole"
        @change:role="$emit('update:selected-position', null)"  />
    </div>

  </div>
</template>

<script>
import IconTacticsBoardPosition from "@/components/IconTacticsBoardPosition";
import TacticsBoardPositionName from "@/components/TacticsBoardPositionName";

export default {
  components: {
    IconTacticsBoardPosition,
    TacticsBoardPositionName
  },

  props: {
    position: Object,
    selectedRole: Object,
    dragging: Object,
    selected: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    positionDrop: function(targetPosition) {
      if (targetPosition.filled) return;
      this.$store.commit("setPositionFilled", {
        position: "player"+targetPosition.positionNumber,
        filled: true
      });
      this.$store.commit("setPositionFilled", {
        position: "player"+this.dragging.positionNumber,
        filled: false
      });
      this.$emit("update:dragging", null);
    }
  }
}
</script>

<style scoped>
  .pos1 { grid-column-start: 1; }
  .pos2 { grid-column-start: 2; }
  .pos3 { grid-column-start: 3; }
  .pos4 { grid-column-start: 4; }
  .pos5 { grid-column-start: 5; }

  .position {
    width: 100%;
  }

  .position-container,
  .position-icon-container {
    min-width: 50%;
    overflow-x: clip;
  }

  .position--accepts-drop:empty {
    width: 50%;
    margin: 0 auto;
    border: solid rgba(0,0,0,.25);
  }

  .role-select {
    opacity: 0;
  }
</style>
